import { Component } from '@theme/component';

class FeaturedStory extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.bindVideo();
  }

  updatedCallback() {
    super.updatedCallback();
    this.bindVideo();
  }

  bindVideo() {
    this.listeners?.abort();
    this.listeners = new AbortController();
    const previousVideo = this.video;
    this.video = this.querySelector('video');
    if (previousVideo && previousVideo !== this.video) previousVideo.pause();
    this.playButton = this.querySelector('.jf-film-card__play');
    this.errorMessage = this.querySelector('.jf-film-card__error');
    if (!this.video || !this.playButton) return;
    this.playButton.hidden = this.video.currentTime > 0 || !this.video.paused;
    const options = { signal: this.listeners.signal };
    this.video.addEventListener('play', () => {
      this.playButton.hidden = true;
      this.errorMessage.hidden = true;
      this.dispatchEvent(new CustomEvent('jf:featured-video-play', { bubbles: true }));
    }, options);
    this.video.addEventListener('error', () => {
      this.errorMessage.hidden = false;
      this.playButton.hidden = false;
      this.playButton.disabled = false;
    }, options);
    document.addEventListener('jf:featured-video-play', event => {
      if (event.target !== this) this.video.pause();
    }, options);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.video.pause();
    }, options);
  }

  async startVideo() {
    if (!this.video || !this.playButton) return;
    const video = this.video;
    this.playButton.disabled = true;
    this.errorMessage.hidden = true;
    try {
      await video.play();
      if (this.isConnected && video === this.video) video.focus({ preventScroll: true });
    } catch {
      if (this.isConnected && video === this.video) {
        this.playButton.hidden = false;
        this.errorMessage.hidden = false;
        this.playButton.focus({ preventScroll: true });
      }
    } finally {
      if (this.isConnected && video === this.video) this.playButton.disabled = false;
    }
  }

  disconnectedCallback() {
    this.video?.pause();
    this.listeners?.abort();
    super.disconnectedCallback();
  }
}

if (!customElements.get('jf-featured-story')) customElements.define('jf-featured-story', FeaturedStory);
